import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AuthInterceptor implements HttpInterceptor
{
	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
	{
		req.headers.append('Content-Type', 'application/json');
		req = req.clone({
			withCredentials: true,
			reportProgress: true
		});
		return next.handle(req);
	}
}



// WEBPACK FOOTER //
// ./src/app/auth-interceptor.service.ts